import React, { useState, useEffect, useRef } from "react";
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const RoundToNearestTen = () => {
  const [currentNumber, setCurrentNumber] = useState(0);
  const [userInput, setUserInput] = useState("");
  const [feedback, setFeedback] = useState("");
  const [isCorrect, setIsCorrect] = useState(false);
  const [showNext, setShowNext] = useState(false);
  const [feedbackClass, setFeedbackClass] = useState("");
  const [inactive, setInactive] = useState(false);
  const timerRef = useRef(null);

  // 🎤 Funny voice
  const speak = (text) => {
    if ("speechSynthesis" in window) {
      const msg = new SpeechSynthesisUtterance(text);
      msg.pitch = 1.8; // higher pitch → funny
      msg.rate = 1.2; // slightly faster
      const voices = speechSynthesis.getVoices();
      msg.voice = voices.find((v) => v.name.includes("Fred") || v.name.includes("Google UK English Male")) || voices[0];
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(msg);
    }
  };

  useEffect(() => {
    generateNumber();
  }, []);

  useEffect(() => {
    if (feedback) speak(feedback);
  }, [feedback]);

  const generateNumber = () => {
    const number = Math.floor(Math.random() * 78 + 21);
    setCurrentNumber(number);
    setUserInput("");
    setFeedback("");
    setIsCorrect(false);
    setShowNext(false);
    setFeedbackClass("");
    resetTimer();
  };

  const roundToNearestTen = (num) => {
    return Math.round(num / 10) * 10;
  };

  const handleCheck = () => {
    const input = parseInt(userInput);
    if (isNaN(input)) {
      setFeedback("Please enter a number!");
      setFeedbackClass("incorrect");
      setIsCorrect(false);
      resetTimer();
      return;
    }

    const correctAnswer = roundToNearestTen(currentNumber);
    if (input === correctAnswer) {
      const successMessages = [
        ` Correct! ${currentNumber} rounds to ${correctAnswer}`,
        `Woohoo! ${currentNumber} becomes ${correctAnswer}!`,
        `Smart move! ${correctAnswer} is right!`,
      ];
      const randomMsg = successMessages[Math.floor(Math.random() * successMessages.length)];

      setFeedback(randomMsg);
      setIsCorrect(true);
      setShowNext(true);
      setFeedbackClass("correct");

      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setFeedback(`Oops! ${userInput} isn’t right. Try again!`);
      setIsCorrect(false);
      setFeedbackClass("incorrect");
    }
    resetTimer();
  };

  // 🕒 Timer to collapse if idle
  const resetTimer = () => {
    clearTimeout(timerRef.current);
    setInactive(false);
    timerRef.current = setTimeout(() => {
      setInactive(true);
    }, 20000);
  };

  return (
    <div
      className={`game-container ${inactive ? "collapsed" : ""}`}
      style={{
        margin: 0,
        fontFamily: "'Comic Sans MS', cursive, sans-serif",
        background: "linear-gradient(to right,rgb(53, 196, 253), #a8dadc)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        transition: "transform 0.6s ease, opacity 0.6s ease",
      }}
      onClick={resetTimer}
      onKeyDown={resetTimer}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
          padding: "30px",
          textAlign: "center",
          width: "500px",
        }}
      >
        <h3 style={{ color: "#1d3557" }}>🔢 Round to Nearest Ten</h3>

        {/* 🎭 Avatar */}
        <img
          src={
            feedbackClass === "correct"
              ? "https://avataaars.io/?avatarStyle=Transparent&topType=LongHairStraight&accessoriesType=Prescription01&hairColor=SilverGray&facialHairType=Blank&clotheType=BlazerSweater&eyeType=Side&eyebrowType=UpDownNatural&mouthType=Smile&skinColor=Light"
              : feedbackClass === "incorrect"
              ? "https://avataaars.io/?avatarStyle=Transparent&topType=LongHairBigHair&accessoriesType=Prescription01&hairColor=SilverGray&facialHairType=BeardLight&facialHairColor=BrownDark&clotheType=BlazerSweater&clotheColor=Blue02&eyeType=Side&eyebrowType=UpDownNatural&mouthType=Smile&skinColor=Pale"
              : "https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairTheCaesar&accessoriesType=Wayfarers&hatColor=Pink&hairColor=SilverGray&facialHairType=BeardLight&facialHairColor=BrownDark&clotheType=BlazerSweater&eyeType=Side&eyebrowType=UpDownNatural&mouthType=Sad&skinColor=Light"
          }
          alt="character"
          style={{ width: 120, height: 120, margin: "0 auto 20px" }}
        />

        <h2 style={{ margin: "10px 0", color: "#222" }}>
          Round this number to the nearest 10: <br /> <span style={{ fontSize: "2rem" }}>{currentNumber}</span>
        </h2>

        <input
          type="number"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          placeholder="Your answer"
          style={{
            fontSize: "1.5rem",
            padding: "8px 15px",
            borderRadius: 12,
            border: "3px solid #004d40",
            width: "100%",
            textAlign: "center",
            outline: "none",
            marginBottom: 20,
          }}
          onKeyDown={(e) => e.key === "Enter" && handleCheck()}
        />
        <br />

        {!showNext && (
          <button
            onClick={handleCheck}
            style={{
              fontSize: "1rem",
              padding: "10px 20px",
              margin: "5px",
              border: "none",
              backgroundColor: "#457b9d",
              color: "#fff",
              borderRadius: "20px",
              cursor: "pointer",
            }}
          >
            Check
          </button>
        )}

        {showNext && (
          <button
            onClick={generateNumber}
            style={{
              fontSize: "1rem",
              padding: "10px 20px",
              margin: "5px",
              border: "none",
              backgroundColor: "#e63946",
              color: "#fff",
              borderRadius: "20px",
              cursor: "pointer",
            }}
          >
            Next
          </button>
        )}

        <div
          style={{
            fontSize: "1.2rem",
            marginTop: "10px",
            minHeight: "30px",
            fontWeight: "700",
            color: feedbackClass === "correct" ? "green" : "red",
          }}
        >
          {feedback}
        </div>
      </div>
    </div>
  );
};

export default RoundToNearestTen;
